// api.js
const BASE_URL = process.env.REACT_APP_BASE_URL || process.env.BASE_URL || 'http://192.168.29.250:5008';
console.log('Using API Base URL:', BASE_URL);

async function request(path, options = {}) {
  const response = await fetch(`${BASE_URL}${path}`, {
    headers: {
      'Content-Type': 'application/json'
    },
    ...options,
  });

  // Parse JSON body (if any)
  let data = {};
  const contentType = response.headers.get('content-type');
  if (contentType && contentType.includes('application/json')) {
    data = await response.json().catch(() => ({}));
  }

  // Return both status and parsed data
  return {
    status: response.status,
    ok: response.ok,
    ...data,
  };
}

export async function sendOtp(mobile, requester) {
  return request('/api/web/otp/send', {
    method: 'POST',
    body: JSON.stringify({ mobile, requester })
  });
}

export async function verifyOtp(mobile, otp, requester, device_token = 'device_token_123') {
  return request('/api/web/otp/verify', {
    method: 'POST',
    body: JSON.stringify({ mobile, otp, requester, device_token })
  });
}

export async function registerUser(payload) {
  const formData = new FormData();
  formData.append('name', payload.name || '');
  formData.append('email', payload.email || '');
  formData.append('mobile', payload.mobile || '');
  formData.append('otp', payload.otp || '');
  formData.append('device_token', payload.device_token || 'device_token_123');
  
  if (payload.profile_pic instanceof File) {
    formData.append('profile_pic', payload.profile_pic);
  } else {
    formData.append('profile_pic', '');
  }
  formData.append('addresses', payload.addresses || '');

  const response = await fetch(`${BASE_URL}/api/web/register`, {
    method: 'POST',
    body: formData
  });

  const data = await response.json().catch(() => ({}));
  console.log('Register API HTTP Status:', response.status);
  console.log('Register API Parsed Body Data:', data);

  return {
    status: response.status,
    ok: response.ok,
    ...data,
  };
}

export async function loginUser(mobile, otp, device_token = 'device_token_123') {
  return request('/api/web/login-user', {
    method: 'POST',
    body: JSON.stringify({ mobile, otp, device_token })
  });
}

export async function loginTechnician(mobile, otp, device_token = 'device_token_123') {
  return request('/api/web/login-technician', {
    method: 'POST',
    body: JSON.stringify({ mobile, otp, device_token })
  });
}

export async function getProfile(token) {
  const response = await fetch(`${BASE_URL}/api/web/get-profile`, {
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {})
    }
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data?.message || 'Failed to fetch profile');
  return { status: response.status, ...data };
}

export async function updateProfile(token, payload) {
  console.log('Updating profile with payload:', payload);
  const response = await fetch(`${BASE_URL}/api/web/update-profile`, {
    method: 'PUT',
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {})
    },
    body: payload  // expects FormData for multipart file upload
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data?.message || 'Failed to update profile');
  return { status: response.status, ...data };
}

/**
 * Update user address
 * @param {string} token - Bearer token
 * @param {string} addressId - The address _id from the user profile
 * @param {object} addressData - JSON object with building_number, block, land_mark, city, pincode
 */
export async function updateAddress(token, addressId, addressData) {
  console.log('Updating address with data:', addressData);
  const response = await fetch(`${BASE_URL}/api/web/update-address/${addressId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {})
    },
    body: JSON.stringify(addressData)
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data?.message || 'Failed to update address');
  return { status: response.status, ...data };
}